import { reactive } from 'vue'

// Shared registry for "root component refs". The Vue 2 codebase registered
// component instances on `this.$root.$refs.X = this` and read them from any
// descendant as `this.$root.$refs.X.method()`. In Vue 3 the root instance's
// $refs is non-extensible, so that mutation throws.
//
// Components write themselves here in `created()` and other components read
// them via `this.$appRoot.X.method(...)`. Reactive so templates that read
// e.g. `$appRoot.BaseLayout.isEmployee` re-render when the field changes.
// Pre-seeded with the names the codebase actually uses so reading any of them
// before the owning component mounts returns null rather than `undefined.foo`.
export const appRoot = reactive({
  AppCyrus: null,
  BaseLayout: null,
  Dashboard: null,
  Leave: null,
  list: null,
  listCompany: null,
  NewEditEmployee: null,
  People: null,
  Reports: null,
  RunOverview: null,
  RunPayroll: null,
  Setting: null,
  SubscriptionPayment: null,
  UpdateRunPayroll: null,
})
